import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        question: '=',
        form: '=',
        counter: '=',
        answeredQuestions: '=',
        disabled: '<'
    },
    template: `
        <div class="alert alert-danger" ng-if="vm.form.answers[vm.question.id].errors.answerId">{{ vm.form.answers[vm.question.id].errors.answerId }}</div>
        <h3 ng-bind-html="vm.questionName | isRequired: vm.question.formQuestions[0].isRequired"></h3>
        <ul class="items10">
            <li ng-if="vm.question.imageFilename" ng-style="{ 'background-image': 'url('+vm.QuestionService.getImageUrl(vm.question, 'small')+')' }">
                <a class="overlay" ng-click="vm.openImageModal(vm.question)">{{ 'general.Zoom in' | translate }}</a>
            </li>
        </ul>
        <table class="question-grid">
             <colgroup>
                <col width="30%"/>
                <col ng-repeat="answer in vm.question.questionAnswers" width="{{ vm.calculateColPercent() }}%"/>
            </colgroup>
            <thead>
                <tr>
                    <th>&nbsp;</th>
                    <th ng-repeat="answer in vm.question.questionAnswers">{{ answer.text }}</th>
                </tr>
            </thead>
            <tbody>
                <tr ng-repeat="(questionIndex,subQuestion) in vm.question.childQuestions">
                    <th class="nobold">{{ subQuestion.nameWithoutHtml }}</th>
                    <td ng-repeat="(answerIndex, answer) in vm.question.questionAnswers">
                        <label>
                            <input type="radio"
                                ng-model="vm.answer.childAnswers[questionIndex].answerId"
                                ng-value="answer.id"
                                ng-change="vm.onChange()"
                                name="question-{{ subQuestion.id }}"
                                ng-disabled="vm.disabled"
                            >
                            <span>{{ answer.text }}</span>
                        </label>
                    </td>
                </tr>
            </tbody>
        </table>
    `
})
export default class {
    constructor ($window, lodash, QuestionService) {
        this.$window = $window;
        this.lodash = lodash;
        this.QuestionService = QuestionService;
    }

    $onInit () {
        this.answer = this.getAnswerStructure(this.question);
        this.answer.childAnswers = this.question.childQuestions.map(question => this.getAnswerStructure(question));
        this.form.answers[this.question.id] = this.answer;
        this.isAnswered = false;
        this.questionName = `${this.counter}. ${this.question.activeI18n.name}`;
        this.updateAnsweredCount();
    }

    // as first row is hardcoded to 30%, we need to divide other space equally between all question answers
    calculateColPercent () {
        if (!this.question.questionAnswers.length) {
            // for some edge case no answers are assigned to question
            return 70;
        }
        return `${this.$window.Math.round(70 / this.question.questionAnswers.length)}`;
    }

    getAnswerStructure (question) {
        return {
            id: question.submittedAnswer ? question.submittedAnswer.id : null,
            answerId: question.submittedAnswer ? question.submittedAnswer.answerId : null,
            questionId: question.id,
            parentId: question.parentId ? question.parentId : null,
            language: this.form.language
        };
    }

    onChange () {
        if (this.isAnswered) {
            return;
        }
        this.updateAnsweredCount();
    }

    updateAnsweredCount () {
        const answerCount = this.answer.childAnswers.filter(answer => answer.answerId).length;
        if (answerCount === this.question.childQuestions.length) {
            this.isAnswered = true;
            this.answeredQuestions = this.answeredQuestions + 1;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/survey/public/survey/question/matrix/index.js